module.exports = __webpack_public_path__ + "img/data_icon7.ba13740a.png";